<template>
    <div class="rounded-muval-1 flex h-5 w-fit items-center px-2 text-xs font-medium">
        <slot>Lozenge</slot>
    </div>
</template>
<script setup>
defineProps({
    rounded: {
        type: Boolean,
        required: false,
        default: false,
    },
});
</script>
